<template>
  <campaignSection v-if="info && info.id" :fields="allNames" :section="section" :no-reset="true">
    <LoyaltyDependencies multiplePagination :tabs-entity="section.tabs" />
  </campaignSection>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import Field from "@/components/loyalty/components/field/Index.vue";
import fieldsMixin from "@/components/loyalty/entity/campaign/mixins/fieldsMixin";
import {cloneDeep} from "lodash/lang";
import LoyaltyDependencies from "@/components/loyalty/entity/campaign/page/dependences/LoyaltyDependencies";
export default {
  name: "EntityDependencies",
  props: {
    vObj: Object
  },

  mixins: [fieldsMixin],

  components: {
    LoyaltyDependencies
  },

  data() {
    return {
      generalConfig: []
    }
  },
}
</script>

<style lang="scss" scoped>
.max--500 {
  max-width: 500px;
}
</style>
